/* unplugin-vue-components disabled */
// TODO: refactor to store
import {Rest} from 'utils'
import {API2_SHCOMPANIES} from 'consts/api2'
import {CompanySuggestion} from 'components/search-dropdown'

export default {
  components: {CompanySuggestion},
  mixins: [ModelValue(String)],
  props: {
    required: {type: Boolean, default: true},
    placeholder: {type: String, default: undefined},
    excludeIds: {type: Array, default: () => []},
  },
  data() {
    return {
      el_value: undefined,
      rest: new Rest(),
      last_query: '',
      last_res: []
    }
  },
  computed: {
    empty() {
      return !this.value
    }
  },
  async mounted() {
    if (this.value) {
      const comp = await this.rest.get(`${API2_SHCOMPANIES}/${this.value}`)
      this.el_value = this.formatLabel(comp)
    }
  },
  methods: {
    focus() {
      this.$refs.el_autocomplete.focus()
    },
    formatLabel(comp) {
      return `${comp.name} ${comp.linkedin_id ? '(' + comp.linkedin_id + ')' : ''}`
    },
    async loadAsync(query, cback) {
      if (!query) return cback([])
      if (this.last_query == query) return cback(this.last_res)

      const {view_items} = await this.rest.get(API2_SHCOMPANIES, {limit: 10, filter: query, exclude_ids: this.excludeIds})
      if (!view_items?.length) {
        this.last_query = query
        this.last_res = []
        return cback([])
      }
      
      const res = []
      for (let comp of view_items) {
        res.push({
          label: this.formatLabel(comp),
          value: comp.id,
          ...comp
        })
      }

      this.last_query = query
      this.last_res = res
      cback(res)
    },
    onInput(item) {
      this.resetInput()
    },
    onSelect(item) {
      this.value = item.value
    },
    abortAll() {
      this.rest.abortAll()
    },
    resetInput(){
      this.abortAll()
      this.$refs.el_autocomplete.suggestions = []
      this.value = undefined
    },
    clear(){
      this.resetInput()
      this.$refs.el_autocomplete.close()
      this.el_value = undefined
    }
  }
}
